import { Search } from 'lucide-react';
import './HomeHeader.css';

interface Props {
    trackCount: number;
    query: string;
    onQueryChange: (query: string) => void;
}

export function HomeHeader({ trackCount, query, onQueryChange }: Props): React.JSX.Element {
    return (
        <div className="homeHeader">
            <div className="homeHeaderText">
                <span className="homeHeaderEyebrow">Your library</span>
                <h1 className="homeHeaderTitle">Tonight's shelf</h1>
            </div>
            <span className="homeSearch">
                <Search size={16} strokeWidth={2.75} />
                <input
                    type="text"
                    placeholder={`Search ${trackCount.toLocaleString()} tracks`}
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                />
            </span>
        </div>
    );
}
